import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";

import { PlayCircleOutline } from "@material-ui/icons";
import { ModalVideo } from "../../../pages/sections/VideoSection/ModalVideo";
import styles from "./styles";

const VideoCard = ({ titleMain, description, urlVideo }) => {
  const classes = styles();
  const [open, setOpen] = useState(false);
  const [dataVideo, setDataVideo] = useState({
    title: "",
    url: ""
  });

  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = (title, url) => {
    setDataVideo({
      title,
      url
    });
    setOpen(true);
  };
  return (
    <div>
      <ModalVideo
        open={open}
        handleClose={handleCloseModal}
        url={dataVideo.url}
        title={dataVideo.title}
      />
      <Paper
        elevation={0}
        className={classes.paper}
        onClick={() => handleOpenModal(titleMain, urlVideo)}
      >
        <h3 className={classes.cardTtitle}>{titleMain}</h3>
        <p className={classes.cardDescription}>{description}</p>
        <div className={classes.playIndicator}>
          <span className={classes.marginRight1}>1:20 </span>
          <PlayCircleOutline color="primary" />
        </div>
      </Paper>
      <div style={{ width: "10px", height: "100%", background: "white" }}></div>
    </div>
  );
};

export default VideoCard;

VideoCard.propTypes = {
  titleMain: PropTypes.string,
  description: PropTypes.string,
  urlVideo: PropTypes.string
};
